import { isEmpty } from 'lodash';
import { QUESTIONNAIRE_CONFIG } from 'modules/cySecQuestionnaire/constants';
import { createSelector } from 'reselect';

export const cySecQuizSelector = (state) => state.cySecQuestionnaire;
export const getCySecQuestions = createSelector(cySecQuizSelector, (quiz) => {
  return quiz.questions;
});

export const getCySecAnswers = createSelector(cySecQuizSelector, (quiz) => {
  return quiz.answers;
});

export const getQuestionnaireTypeIndex = createSelector(
  getCySecQuestions,
  getCySecAnswers,
  (questions, answers) => {
    const configs = QUESTIONNAIRE_CONFIG;
    const index = getQuestionnaireIndex(configs, questions, answers);

    return index === -1 ? configs.length - 1 : index;
  },
);

const getQuestionnaireIndex = (configs, questions, answers) => {
  if (isEmpty(answers) || isEmpty(questions)) {
    return 0;
  }

  const index = configs.findIndex((config) => {
    const questionsByType = questions[config.type];
    return !hasAllAnswers(config.categories, questionsByType, answers[config.type]);
  });

  return index;
};

export const checkCompletedQuestionnaire = createSelector(
  getCySecQuestions,
  getCySecAnswers,
  (questions, answers) => {
    const configs = QUESTIONNAIRE_CONFIG;
    const index = getQuestionnaireIndex(configs, questions, answers);

    return index === -1;
  },
);

const hasAllAnswers = (categories, questions, answers) => {
  return categories.every((category) => {
    const categoryQuestions = questions[category];

    const answerKeys = Object.keys(answers || {});

    return categoryQuestions.every((question) =>
      answerKeys.some((key) => question._id === key || question.group?.some((x) => x._id === key)),
    );
  });
};

export const getCurrentFormIndex = createSelector(
  cySecQuizSelector,
  getQuestionnaireTypeIndex,
  (quiz, activeStep) => {
    const needToBeFill = quiz.currentStep > activeStep;
    return needToBeFill || quiz.currentStep === null ? activeStep : quiz.currentStep;
  },
);

export const getShowRecheckModal = createSelector(cySecQuizSelector, (quiz) => {
  return quiz.showRecheckModal;
});
